<template>
  <div>
    <SjInputField
      label="账号"
      v-model="value"
      style="width: 400px"
      icon-class="comselect_info"
    />

    <SjInputField
      label="账号"
      v-model="value"
      style="width: 400px;margin-top: 20px"
      icon-class="comselect_info"
    >
      <div slot="label">
        label
      </div>
    </SjInputField>

    <SjInputField
      label="账号"
      :value="value"
      style="width: 400px;margin-top: 20px"
      icon-class="comselect_info"
      disabled
    >
      <div slot="label" style="color: red">
        自定义
      </div>
    </SjInputField>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: null
    };
  }
};
</script>

<style scoped lang="less"></style>
